import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import FilteredGroupsSelector from '../../contacts/FilteredGroupsSelector';

const CopyContactsDialog = ({ onClose, onConfirm, onCreateGroup, open = true }) => {
    const [selectedGroups, setSelectedGroups] = useState([]);

    const handleConfirm = e => {
        e.preventDefault();
        onConfirm(selectedGroups);
        onClose();
    };

    useEffect(() => {
        !open && setSelectedGroups([]);
    }, [open]);

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>Add Contacts to Group(s)</DialogTitle>
            <FilteredGroupsSelector
                selectedGroups={selectedGroups}
                setSelectedGroups={setSelectedGroups}
                spacing={3}
                popperGutters={3}
                onCreateGroup={onCreateGroup}
            />
            <DialogActions>
                <Button onClick={handleConfirm} disabled={selectedGroups.length === 0}>Confirm</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CopyContactsDialog;